import { Component } from 'react';
import {connect} from 'react-redux';
import {Container} from 'react-bootstrap';
import PageTitle from '../../../common/page-title/index';
import {getSmsLogs} from '../../../../actions/logs';
import withPaginatedFilter from '../../../common/withPaginatedFilter';
import NotificationFilter from '../notification-filter';
import SmsNotificationsTable from './sms-notification-table';
import LogBody from '../log-body';

class SmsLogs extends Component {
  formatSms = sms => ({
    id: sms.id,
    sms: this.createBody(sms)
  });

  createBody = sms => (
    <LogBody.mobile
      to={sms.attributes.mobile}
      message={sms.attributes.body}
      sent={sms.attributes['sent-date']}
    />
  );

  render() {
    const {
      smses, paging, pageNumber, doSearch, query, handleChange, handleClear, handleSearch, handlePageChange
    } = this.props;

    const data = smses.map(this.formatSms);

    return (
      <Container fluid className="notifications">
        <PageTitle>Sms notification logs</PageTitle>

        <NotificationFilter
          onChange={handleChange}
          onClear={handleClear}
          onSearch={handleSearch}
          doSearch={doSearch}
          searchValue={query}
        />

        <SmsNotificationsTable
          notifications={data}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
          paging={paging}
          searchValue={query}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  smses: state.notificationLog.smsList,
  paging: state.notificationLog.paging,
  fetched: state.notificationLog.fetched,
  fetching: state.notificationLog.fetching,
});

export default connect(mapStateToProps)(withPaginatedFilter(SmsLogs, getSmsLogs));
